/* Shopify Forms teaser - restyled to match the Shopify Inbox "Need help?" button.

   The "Get 10% Off" teaser (shown after the email pop-up is dismissed) is
   rendered by the Shopify Forms app embed inside an OPEN shadow root on
   <shopify-forms-embed>, so theme CSS cannot reach it. This script injects a
   style element into that shadow root.

   Target values were measured from the Inbox chat button on 26 Oct 2026:
   black at 70% opacity, square corners, 47px tall, 16px side padding, 8px gap,
   Barlow 14px/400 white, a 17px outlined icon at 70% white (a tag here, not Inbox's chat bubble), and
   Inbox's layered soft shadow. The Forms markup uses hashed class names that
   change between app releases, so only stable hooks are targeted:
   [data-testid="form-teaser"], its h3, and the [aria-label="Close modal"] X.
*/
(function () {
  // Outlined price tag, drawn to match the weight of Inbox's chat-bubble icon
  // (16px box, 1.25 stroke). A chat bubble would wrongly suggest live chat.
  var ICON =
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='black' stroke-width='1.25'%3E%3Cpath d='M8.4 2.625H3.5a.875.875 0 0 0-.875.875V8.4c0 .332.132.65.366.884l5.1 5.1a1.25 1.25 0 0 0 1.768 0l4.016-4.016a1.25 1.25 0 0 0 0-1.768l-5.1-5.1a1.25 1.25 0 0 0-.884-.366Z'/%3E%3Ccircle cx='5.6' cy='5.6' r='1'/%3E%3C/svg%3E\")";

  var CSS =
    '[data-testid="form-teaser"]{' +
      'background:rgba(0,0,0,.7)!important;color:#fff!important;border:0!important;border-radius:0!important;' +
      'min-height:47px!important;height:47px!important;padding:0 16px!important;gap:8px!important;' +
      'display:inline-flex!important;align-items:center!important;' +
      'font-family:Barlow,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif!important;' +
      'box-shadow:rgba(0,0,0,.05) 0 2px 2px -1px,rgba(0,0,0,.05) 0 3px 4px -1.5px,rgba(0,0,0,.05) 0 4px 8px -2px,rgba(0,0,0,.05) 0 5px 16px -2.5px,rgba(0,0,0,.08) 0 0 0 1px!important;' +
    '}' +
    '[data-testid="form-teaser"] h3{' +
      'display:inline-flex!important;align-items:center!important;gap:8px!important;margin:0!important;' +
      'font-family:inherit!important;font-size:14px!important;font-weight:400!important;line-height:1!important;' +
      'letter-spacing:normal!important;text-transform:none!important;color:#fff!important;' +
    '}' +
    '[data-testid="form-teaser"] h3::before{' +
      'content:"";flex:0 0 17px;width:17px;height:17px;background:rgba(255,255,255,.7);' +
      '-webkit-mask:' + ICON + ' center/contain no-repeat;mask:' + ICON + ' center/contain no-repeat;' +
    '}' +
    '[data-testid="form-teaser"] [aria-label="Close modal"]{' +
      'position:static!important;display:inline-flex!important;align-items:center!important;margin:0!important;padding:0!important;' +
      'width:auto!important;height:auto!important;background:none!important;color:rgba(255,255,255,.7)!important;' +
    '}' +
    '[data-testid="form-teaser"] [aria-label="Close modal"] svg{width:10px!important;height:10px!important;fill:currentColor!important}' +
    '[data-testid="form-teaser"] [aria-label="Close modal"] path{fill:currentColor!important}';

  function style(host) {
    var root = host.shadowRoot;
    if (!root || root.querySelector('style[data-xs-teaser]')) return;
    var s = document.createElement('style');
    s.setAttribute('data-xs-teaser', '');
    s.textContent = CSS;
    root.appendChild(s);
  }

  // POSITION, 26 Oct 2026. Forms pins its teaser 25px from the bottom-left
  // corner while Inbox sets its own offsets per breakpoint, so the two sat at
  // different heights. Rather than hard-code Inbox's numbers (which it changes
  // between desktop and mobile), measure the chat button and move the teaser
  // so its bottom edge lines up with the chat button's, and its gap to the
  // left edge equals the chat button's gap to the right edge. Uses the CSS
  // `translate` property so it never fights the fade animation's transform.
  function findChatButton(root, depth) {
    if (!root || depth > 6) return null;
    var hit = root.querySelector('button.activator');
    if (hit) return hit;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) {
        var found = findChatButton(all[i].shadowRoot, depth + 1);
        if (found) return found;
      }
    }
    return null;
  }

  var chatHost = null;
  function align(host) {
    var root = host.shadowRoot;
    var teaser = root && root.querySelector('[data-testid="form-teaser"]');
    if (!teaser) return;
    if (!chatHost || !chatHost.isConnected) chatHost = document.querySelector('shopify-chat');
    var chat = chatHost && findChatButton(chatHost.shadowRoot, 0);
    var cr = chat && chat.getBoundingClientRect();
    if (!cr || !cr.height) {
      teaser.style.translate = '';
      return;
    }
    var cur = (teaser.style.translate || '0px 0px').split(' ');
    var cx = parseFloat(cur[0]) || 0;
    var cy = parseFloat(cur[1]) || 0;
    var tr = teaser.getBoundingClientRect();
    if (!tr.height) return;
    var dy = Math.round(cr.bottom - (tr.bottom - cy));
    var dx = Math.round((window.innerWidth - cr.right) - (tr.left - cx));
    var next = dx + 'px ' + dy + 'px';
    if (teaser.style.translate !== next) teaser.style.translate = next;
  }

  function scan() {
    var hosts = document.querySelectorAll('shopify-forms-embed');
    for (var i = 0; i < hosts.length; i++) {
      style(hosts[i]);
      align(hosts[i]);
    }
  }

  function start() {
    scan();
    // Both widgets mount after load, re-render, and Inbox moves its button
    // between breakpoints, so re-check on a light timer and on resize.
    setInterval(scan, 750);
    window.addEventListener('resize', scan);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
